import { Button, Tab, Tabs, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { CategoryTabState, State } from '../../utils/types/state.types';

import { useState } from 'react';
import Page from '../../components/Page';
import TabPanel from '../../components/containers/TabPanel';
import PlusIcon from '../../components/icons/PlusIcon';
import { CATEGORIES_ROUTES } from '../../utils/constants/routes.constants';
import { useRights } from '../../utils/hooks';
import { fonts } from '../../utils/theme/fonts.theme';
import { BrandsPanel } from './BrandsPanel';
import { CategoriesPanel } from './CategoriesPanel';
import { InternalCategoriesPanel } from './InternalCategoriesPanel';

const CategoriesPage = () => {
    const { state }: State<CategoryTabState> = useLocation();
    const [currentTab, setCurrentTab] = useState(state?.currentTab ?? 0);
    const navigate = useNavigate();

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setCurrentTab(newValue);
    };

    const isAdmin = useRights(['ADMIN']);

    return (
        <Page>
            <div style={{ display: 'flex' }}>
                <Typography style={fonts.pageTitle} flexGrow={1}>
                    Catégories
                </Typography>

                {currentTab === 0 && (
                    <Button
                        variant="contained"
                        onClick={() => navigate(CATEGORIES_ROUTES.ADD_CATEGORY)}
                        disabled={!isAdmin}
                    >
                        <PlusIcon />
                        Ajouter une catégorie
                    </Button>
                )}
                {currentTab === 1 && (
                    <Button
                        variant="contained"
                        sx={{ marginRight: '16px' }}
                        onClick={() => navigate(CATEGORIES_ROUTES.ADD_INTERNAL_CATEGORY)}
                        disabled={!isAdmin}
                    >
                        <PlusIcon />
                        Ajouter une catégorie interne
                    </Button>
                )}
                {currentTab === 2 && (
                    <Button
                        variant="contained"
                        sx={{ marginRight: '16px' }}
                        onClick={() => navigate(CATEGORIES_ROUTES.ADD_BRAND)}
                        disabled={!isAdmin}
                    >
                        <PlusIcon />
                        Ajouter une marque
                    </Button>
                )}
            </div>

            <Tabs value={currentTab} onChange={handleChange}>
                <Tab label="Catégories" />
                <Tab label="Catégories internes" />
                <Tab label="Marques" />
            </Tabs>

            <TabPanel value={currentTab} index={0}>
                <CategoriesPanel />
            </TabPanel>

            <TabPanel value={currentTab} index={1}>
                <InternalCategoriesPanel />
            </TabPanel>

            <TabPanel value={currentTab} index={2}>
                <BrandsPanel />
            </TabPanel>
        </Page>
    );
};

export default CategoriesPage;
